export default __webpack_public_path__ + "static/media/no-search-result-saved-icon.45f5b2b7.svg";